/**
 * EMA Reef Assistant — chat widget
 * Vanilla JS, no dependencies, ES2020
 */
(function () {
  'use strict';
  if (window.__emaChatInstalled) return;
  window.__emaChatInstalled = true;

  // ── Config (injected by Liquid) ──────────────────────────────────────────
  var CFG      = window.EMA_CHAT_CFG || {};
  var API_URL  = CFG.apiUrl || '';
  var CUSTOMER = CFG.customer || { isLoggedIn: false };
  if (!API_URL) {
    console.warn('[EMA Chat] API URL not configured. Set window.EMA_CHAT_CFG.apiUrl');
    return;
  }

  var CUSTOMER_ID = CUSTOMER && CUSTOMER.isLoggedIn && CUSTOMER.id ? String(CUSTOMER.id) : null;
  var CHAT_OWNER = CUSTOMER_ID ? 'customer-' + CUSTOMER_ID : 'guest';
  var CHAT_PREFIX = 'ema_chat_v2_' + CHAT_OWNER + '_';
  var SESSION_KEY = CHAT_PREFIX + 'session';
  var STATE_KEY = CHAT_PREFIX + 'state';
  var HISTORY_KEY = CHAT_PREFIX + 'history';
  var HISTORY_TTL = 2 * 60 * 60 * 1000;
  var PROFILE_KEY = CUSTOMER_ID ? 'ema_reef_profile_customer_v2_' + CUSTOMER_ID : CHAT_PREFIX + 'profile';
  var privacyLoading = false;
  var consentWasPreferences = false;
  var consentWasBehavior = false;
  var scopedProfile = null;
  var contextEnginesStarted = false;

  function currentChatScope() {
    var customer = (window.EMA_CHAT_CFG || {}).customer || {};
    return customer.isLoggedIn && customer.id ? 'customer-' + String(customer.id) : 'guest';
  }
  function chatAccountIsCurrent() { return currentChatScope() === CHAT_OWNER; }
  function privacyAllowed(method) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(privacy && typeof privacy[method] === 'function' && privacy[method]()); }
    catch (error) { return false; }
  }
  function preferencesAllowed() { return chatAccountIsCurrent() && privacyAllowed('preferencesProcessingAllowed'); }
  function behaviorAllowed() { return preferencesAllowed() && privacyAllowed('analyticsProcessingAllowed'); }
  function analyticsAllowed() {
    return chatAccountIsCurrent() && privacyAllowed('analyticsProcessingAllowed') && privacyAllowed('marketingAllowed');
  }
  function lsRemove(key) { try { localStorage.removeItem(key); } catch (error) {} }
  function lsGet(key) {
    if (!preferencesAllowed()) return null;
    try { return localStorage.getItem(key); } catch (error) { return null; }
  }
  function lsSet(key, value) {
    if (!preferencesAllowed()) return;
    try { localStorage.setItem(key, value); } catch (error) {}
  }
  function newSessionId() { return 'ema_' + Date.now() + '_' + Math.random().toString(36).slice(2); }
  function emptyState() { return {productViews: {}, proactiveSeen: 0, hasOpenedChat: false, discountOffered: false}; }
  var sessionId = newSessionId();
  var state = emptyState();
  var chatHistory = [];

  function loadScopedRecord(key) {
    try {
      var value = JSON.parse(lsGet(key) || 'null');
      if (!value || value.owner !== CHAT_OWNER || !Number.isFinite(value.ts) || value.ts > Date.now() ||
          Date.now() - value.ts > HISTORY_TTL) return null;
      return value;
    } catch (error) { return null; }
  }
  function saveSession() { lsSet(SESSION_KEY, JSON.stringify({owner:CHAT_OWNER, ts:Date.now(), id:sessionId})); }
  function saveState() {
    var safe = {hasOpenedChat: !!state.hasOpenedChat, discountOffered: !!state.discountOffered};
    if (behaviorAllowed()) safe.productViews = state.productViews;
    lsSet(STATE_KEY, JSON.stringify({owner:CHAT_OWNER, ts:Date.now(), state:safe}));
  }
  function safeMessages(messages) {
    if (!Array.isArray(messages)) return [];
    return messages.filter(function (message) {
      return message && ['user', 'assistant'].indexOf(message.role) !== -1 && typeof message.content === 'string';
    }).slice(-32).map(function (message) { return {role:message.role, content:message.content.slice(0,4000)}; });
  }
  function saveHistory() {
    lsSet(HISTORY_KEY, JSON.stringify({owner:CHAT_OWNER, ts:Date.now(), messages:safeMessages(chatHistory)}));
  }
  function hydrateChatPreferences() {
    if (!preferencesAllowed()) return;
    var previous = loadScopedRecord(SESSION_KEY);
    if (previous && typeof previous.id === 'string' && previous.id.length < 150) sessionId = previous.id;
    var savedState = loadScopedRecord(STATE_KEY);
    if (savedState && savedState.state && !state.hasOpenedChat) {
      state.hasOpenedChat = !!savedState.state.hasOpenedChat;
      state.discountOffered = !!savedState.state.discountOffered;
      if (behaviorAllowed()) state.productViews = savedState.state.productViews || {};
    }
    if (!chatHistory.length) {
      var savedHistory = loadScopedRecord(HISTORY_KEY);
      if (savedHistory) chatHistory = safeMessages(savedHistory.messages);
    }
    saveSession();
  }
  hydrateChatPreferences();
  consentWasPreferences = preferencesAllowed();
  consentWasBehavior = behaviorAllowed();

  // ── Context (set by Liquid + captured live) ───────────────────────────────
  var PAGE_CTX = CFG.context || {};
  var liveCtx  = {
    pageType:        PAGE_CTX.pageType    || 'generic',
    url:             window.location.href,
    product:         PAGE_CTX.product     || null,
    collection:      PAGE_CTX.collection  || null,
    searchQuery:     PAGE_CTX.searchQuery || null,
    referrer:        document.referrer    || null,
    session: {
      timeOnPage:      0,
      scrollDepth:     0,
      productViewCount: Object.keys(state.productViews).length,
      repeatProductView: false,
      cartDwell:       0,
    },
    cart: null,
  };

  var pageStartTime = Date.now();
  var viewCounted = false;
  function recordConsentedView() {
    if (!behaviorAllowed() || viewCounted || !PAGE_CTX.product || !PAGE_CTX.product.handle) return;
    var handle = PAGE_CTX.product.handle;
    var views = state.productViews;
    views[handle] = Math.min(100, (Number(views[handle]) || 0) + 1);
    var keys = Object.keys(views);
    if (keys.length > 100) delete views[keys[0]];
    viewCounted = true;
    liveCtx.session.repeatProductView = views[handle] > 1;
    liveCtx.session.productViewCount = Object.keys(views).length;
    saveState();
  }
  recordConsentedView();
  window.addEventListener('scroll', function () {
    if (!behaviorAllowed()) return;
    var root = document.documentElement;
    var depth = root.scrollHeight ? (root.scrollTop + root.clientHeight) / root.scrollHeight : 0;
    liveCtx.session.scrollDepth = Math.min(1, Math.max(liveCtx.session.scrollDepth, depth));
  }, {passive:true});

  function handleChatPrivacyChange() {
    var preferences = preferencesAllowed();
    var behavior = behaviorAllowed();
    if (!chatAccountIsCurrent()) {
      chatHistory = [];
      scopedProfile = null;
      state = emptyState();
      sessionId = newSessionId();
      if (isOpen) closeChat();
      return;
    }
    if (!preferences) {
      [SESSION_KEY, STATE_KEY, HISTORY_KEY, PROFILE_KEY].forEach(lsRemove);
      if (consentWasPreferences) sessionId = newSessionId();
    } else if (!consentWasPreferences) {
      hydrateChatPreferences();
      saveHistory();
    }
    if (!behavior) {
      state.productViews = {};
      viewCounted = false;
      liveCtx.session = {timeOnPage:0, scrollDepth:0, productViewCount:0, repeatProductView:false, cartDwell:0};
      if (preferences) saveState();
    } else if (!consentWasBehavior) recordConsentedView();
    consentWasPreferences = preferences;
    consentWasBehavior = behavior;
  }
  document.addEventListener('visitorConsentCollected', handleChatPrivacyChange);
  if (!(window.Shopify && window.Shopify.customerPrivacy) && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    privacyLoading = true;
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) {
      privacyLoading = false;
      if (!error && window.Shopify.customerPrivacy) handleChatPrivacyChange();
    });
  }

  function refreshCart() {
    if (!isOpen || !chatAccountIsCurrent()) return Promise.resolve(null);
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return fetch(root.replace(/\/$/,'') + '/cart.js', {headers:{Accept:'application/json'},cache:'no-store'})
      .then(function (response) { if (!response.ok) throw new Error('Cart context unavailable'); return response.json(); })
      .then(function (cart) {
        if (!chatAccountIsCurrent() || !cart || !Array.isArray(cart.items)) return null;
        liveCtx.cart = {item_count:cart.item_count, total_price:cart.total_price, items:cart.items.map(function (item) {
          return {product_id:item.product_id, variant_id:item.variant_id, title:item.product_title || item.title,
            handle:item.handle, product_type:item.product_type, quantity:item.quantity, price:item.price};
        })};
        return liveCtx.cart;
      }).catch(function () { console.warn('[EMA Chat] Cart context is unavailable. Manual chat remains available.'); return null; });
  }
  document.addEventListener('ema:cart-add-success', function () { if (isOpen) refreshCart(); });

  var CHAT_ANALYTICS_EVENTS = ['chatbot_opened','chatbot_closed','product_recommendation_clicked',
    'compatibility_question_asked','shipping_question_asked','livestock_suitability_question',
    'discount_offered','handoff_requested'];
  function trackEvent(event, properties) {
    if (!analyticsAllowed() || CHAT_ANALYTICS_EVENTS.indexOf(event) === -1) return Promise.resolve(false);
    var safe = {};
    properties = properties || {};
    if (['generic','homepage','product','collection','cart','search','page','article','blog'].indexOf(properties.pageType) !== -1) safe.pageType = properties.pageType;
    if (typeof properties.handle === 'string' && /^[a-z0-9-]{1,200}$/.test(properties.handle)) safe.handle = properties.handle;
    if (Number.isInteger(properties.messageCount)) safe.messageCount = Math.max(0,Math.min(100,properties.messageCount));
    return fetch(API_URL + '/api/chat/events', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({session_id:sessionId,event:event,properties:safe})
    }).then(function (response) {
      if (!response.ok) throw new Error('Chat event was not accepted');
      return true;
    }).catch(function () { console.warn('[EMA Chat] Optional analytics event was not accepted.'); return false; });
  }

  // ── DOM refs ──────────────────────────────────────────────────────────────
  var fab, panel, messagesEl, inputEl, typingEl, quickRepliesEl, proactiveBubble;

  // ── Render helpers ────────────────────────────────────────────────────────
  function escHtml(str) {
    return String(str)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function nl2br(str) {
    return escHtml(str).replace(/\n/g, '<br>');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function botAvatarHTML() {
    return '<div class="ema-msg-avatar ema-msg-avatar--bot">' +
      '<img class="ema-msg-bot-logo" src="' + (CFG.logoUrl || '') + '" alt="EMA">' +
    '</div>';
  }

  function renderBotMessage(text, extra) {
    var el = document.createElement('div');
    el.className = 'ema-msg ema-msg--bot';
    el.innerHTML =
      botAvatarHTML() +
      '<div class="ema-msg-body">' +
        '<div class="ema-msg-bubble">' + nl2br(text) + '</div>' +
        (extra || '') +
      '</div>';
    messagesEl.appendChild(el);
    scrollToBottom();
    return el;
  }

  function renderUserMessage(text) {
    var el = document.createElement('div');
    el.className = 'ema-msg ema-msg--user';
    el.innerHTML =
      '<div class="ema-msg-avatar ema-msg-avatar--user" aria-hidden="true">🐠</div>' +
      '<div class="ema-msg-bubble">' + nl2br(text) + '</div>';
    messagesEl.appendChild(el);
    scrollToBottom();
  }

  function stockBadge(p) {
    if (!p.available) return '<span class="ema-stock ema-stock--out">Out of stock</span>';
    var qty = p.totalStock;
    if (typeof qty === 'number' && qty > 0) {
      if (qty === 1)  return '<span class="ema-stock ema-stock--low">Last 1 left</span>';
      if (qty <= 3)   return '<span class="ema-stock ema-stock--low">Only ' + qty + ' left</span>';
      if (qty <= 10)  return '<span class="ema-stock ema-stock--ok">In stock</span>';
      return '<span class="ema-stock ema-stock--ok">In stock</span>';
    }
    return '<span class="ema-stock ema-stock--ok">In stock</span>';
  }

  function renderProductCards(products) {
    if (!products || !products.length) return '';
    var html = '<div class="ema-products">';
    products.forEach(function (p) {
      var desc = p.description ? escHtml(p.description.slice(0, 90)) + (p.description.length > 90 ? '…' : '') : '';
      html +=
        '<a class="ema-product-card" href="' + escHtml(p.url) + '" target="_blank"' +
            ' onclick="window.emaChatTrack && window.emaChatTrack(\'product_recommendation_clicked\',{handle:\'' + escHtml(p.handle) + '\'})">' +
          (p.image ? '<img class="ema-product-img" src="' + escHtml(p.image) + '" alt="' + escHtml(p.title) + '" loading="lazy">' : '<div class="ema-product-img ema-product-img--placeholder"></div>') +
          '<div class="ema-product-info">' +
            '<div class="ema-product-title">' + escHtml(p.title) + '</div>' +
            (desc ? '<div class="ema-product-desc">' + desc + '</div>' : '') +
            '<div class="ema-product-meta">' +
              stockBadge(p) +
              '<span class="ema-product-price">' + formatMoney(p.price * 100) + ' NZD</span>' +
            '</div>' +
          '</div>' +
          '<div class="ema-product-arrow">→</div>' +
        '</a>';
    });
    html += '</div>';
    return html;
  }

  function renderDiscount(discount) {
    return '<div class="ema-discount-card">' +
      '<div class="ema-discount-icon">🎁</div>' +
      '<div class="ema-discount-body">' +
        '<div class="ema-discount-code">' + escHtml(discount.code) + '</div>' +
        '<div class="ema-discount-note">5% off · expires in 24 hours</div>' +
      '</div>' +
      '<button class="ema-discount-copy" onclick="emaCopyChatCode(\'' + escHtml(discount.code) + '\')">Copy</button>' +
    '</div>';
  }

  window.emaCopyChatCode = function (code) {
    navigator.clipboard?.writeText(code).catch(function () {});
    var btn = document.querySelector('.ema-discount-copy');
    if (btn) { btn.textContent = 'Copied!'; setTimeout(function () { btn.textContent = 'Copy'; }, 2000); }
  };

  window.emaChatTrack = trackEvent;

  function renderQuickReplies(replies) {
    if (!quickRepliesEl) return;
    quickRepliesEl.innerHTML = '';
    if (!replies || !replies.length) return;
    replies.slice(0, 4).forEach(function (r) {
      var btn = document.createElement('button');
      btn.className = 'ema-quick-reply';
      btn.textContent = r;
      btn.addEventListener('click', function () {
        sendMessage(r);
        quickRepliesEl.innerHTML = '';
      });
      quickRepliesEl.appendChild(btn);
    });
  }

  function showTyping() {
    if (typingEl) typingEl.hidden = false;
    scrollToBottom();
  }
  function hideTyping() {
    if (typingEl) typingEl.hidden = true;
  }

  function scrollToBottom() {
    if (messagesEl) messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function fishIconSVG() {
    return '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21.17 4.17c-2.08-.75-4.5-.5-6.33.75L12 6.5 9.16 4.92C7.33 3.67 4.91 3.42 2.83 4.17L1 4.83l3 3.67-3 3.67 1.83.66c2.08.75 4.5.5 6.33-.75L12 10.5l2.84 1.58c1.83 1.25 4.25 1.5 6.33.75l1.83-.66-3-3.67 3-3.67z"/><path d="M12 12.5l-2.84 1.58c-1.83 1.25-4.25 1.5-6.33.75l-1.83-.66 3-3.67"/></svg>';
  }

  function waveIconSVG() {
    return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12c1.5-3 3-4.5 4.5-4.5S9 9 10.5 9s3-1.5 4.5-1.5S18 9 19.5 9 22 7.5 22 7.5"/><path d="M2 17c1.5-3 3-4.5 4.5-4.5S9 14 10.5 14s3-1.5 4.5-1.5 3 1.5 4.5 1.5 2.5-1.5 2.5-1.5"/></svg>';
  }

  function sendIconSVG() {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>';
  }

  function closeIconSVG() {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  }

  // ── Build DOM ─────────────────────────────────────────────────────────────
  function buildWidget() {
    // FAB wrapper (holds ripple rings + button + label)
    var fabWrap = document.createElement('div');
    fabWrap.id        = 'ema-fab-wrap';
    fabWrap.className = 'ema-fab-wrap';
    fabWrap.addEventListener('click', toggleChat);

    // Button + rings container
    var fabBtnWrap = document.createElement('div');
    fabBtnWrap.className = 'ema-fab-btn-wrap';

    // Three ripple rings — randomised timing so they never look mechanical
    // Each ring gets a unique random duration (2.5–4.5s) and an initial
    // random delay (0–4s) so the pattern is always different on page load.
    ['1', '2', '3'].forEach(function (n) {
      var ring = document.createElement('div');
      ring.className = 'ema-fab-ring ema-fab-ring--' + n;
      var dur   = (2.5 + Math.random() * 2).toFixed(2) + 's';
      var delay = (Math.random() * 4).toFixed(2) + 's';
      ring.style.setProperty('--ripple-dur',   dur);
      ring.style.setProperty('--ripple-delay', delay);
      fabBtnWrap.appendChild(ring);
    });

    // Floating button
    fab = document.createElement('button');
    fab.id          = 'ema-chat-fab';
    fab.className   = 'ema-chat-fab';
    fab.setAttribute('aria-label', 'Chat with EMA reef assistant');
    fab.setAttribute('aria-haspopup', 'dialog');
    fab.innerHTML   =
      '<img class="ema-chat-fab-img" src="' + (CFG.logoUrl || '') + '" alt="EMA" width="64" height="64">' +
      '<span class="ema-chat-fab-badge" id="ema-chat-badge" hidden>!</span>';
    fabBtnWrap.appendChild(fab);
    fabWrap.appendChild(fabBtnWrap);

    // "EMA Chat" label
    var fabLabel = document.createElement('span');
    fabLabel.className   = 'ema-chat-fab-label';
    fabLabel.textContent = 'EMA Chat';
    fabWrap.appendChild(fabLabel);

    document.body.appendChild(fabWrap);

    // Chat panel
    panel = document.createElement('div');
    panel.id        = 'ema-chat-panel';
    panel.className = 'ema-chat-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'false');
    panel.setAttribute('aria-label', 'EMA Reef Assistant');
    panel.setAttribute('aria-hidden', 'true');
    panel.hidden    = true;
    panel.innerHTML =
      // Header
      '<header class="ema-chat-header">' +
        '<div class="ema-chat-header-left">' +
          '<div class="ema-chat-avatar" aria-hidden="true"><img class="ema-chat-header-logo" src="' + (CFG.logoUrl || '') + '" alt="EMA"></div>' +
          '<div>' +
            '<div class="ema-chat-name">EMA Reef Assistant</div>' +
            '<div class="ema-chat-status">Marine aquarium help</div>' +
          '</div>' +
        '</div>' +
        '<button class="ema-chat-close" aria-label="Close chat" id="ema-chat-close">' + closeIconSVG() + '</button>' +
      '</header>' +

      // Messages
      '<div class="ema-chat-messages" id="ema-chat-messages" role="log" aria-live="polite" aria-label="Chat messages"></div>' +

      // Typing indicator
      '<div class="ema-chat-typing" id="ema-chat-typing" hidden aria-label="EMA is typing" aria-live="polite">' +
        '<div class="ema-chat-typing-inner">' +
          '<div class="ema-msg-avatar ema-msg-avatar--bot"><img class="ema-msg-bot-logo" src="' + (CFG.logoUrl || '') + '" alt="EMA"></div>' +
          '<div class="ema-typing-dots"><span></span><span></span><span></span></div>' +
        '</div>' +
      '</div>' +

      // Quick replies
      '<div class="ema-chat-quick-replies" id="ema-chat-quick-replies" role="group" aria-label="Suggested replies"></div>' +

      // Input area
      '<div class="ema-chat-input-area">' +
        '<textarea id="ema-chat-input" class="ema-chat-input" placeholder="Ask about any product or livestock…" rows="1" aria-label="Chat message"></textarea>' +
        '<button id="ema-chat-send" class="ema-chat-send" aria-label="Send message">' + sendIconSVG() + '</button>' +
      '</div>' +

      // Footer
      '<div class="ema-chat-footer">' +
        '<button class="ema-chat-handoff-btn" id="ema-chat-handoff">Talk to the EMA team</button>' +
        '<p class="ema-chat-disclaimer">AI responses are for guidance only and may not always be accurate. Confirm important decisions with the EMA team.</p>' +
      '</div>';

    document.body.appendChild(panel);

    // Wire up refs
    messagesEl    = document.getElementById('ema-chat-messages');
    inputEl       = document.getElementById('ema-chat-input');
    typingEl      = document.getElementById('ema-chat-typing');
    quickRepliesEl = document.getElementById('ema-chat-quick-replies');

    // Close button
    document.getElementById('ema-chat-close').addEventListener('click', closeChat);

    // Send on button click or Enter (Shift+Enter = newline)
    document.getElementById('ema-chat-send').addEventListener('click', function () {
      submitInput();
    });
    inputEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        submitInput();
      }
    });
    // Auto-resize textarea
    inputEl.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = Math.min(this.scrollHeight, 120) + 'px';
    });

    // Handoff
    document.getElementById('ema-chat-handoff').addEventListener('click', showHandoffForm);

    // Proactive bubble
    proactiveBubble = document.createElement('div');
    proactiveBubble.id        = 'ema-proactive';
    proactiveBubble.className = 'ema-proactive';
    proactiveBubble.hidden    = true;
    proactiveBubble.innerHTML =
      '<button class="ema-proactive-close" id="ema-proactive-close" aria-label="Dismiss">' + closeIconSVG() + '</button>' +
      '<p class="ema-proactive-text" id="ema-proactive-text"></p>' +
      '<button class="ema-proactive-cta" id="ema-proactive-cta">Get help</button>';
    document.body.appendChild(proactiveBubble);

    document.getElementById('ema-proactive-close').addEventListener('click', dismissProactive);
    document.getElementById('ema-proactive-cta').addEventListener('click', function () {
      dismissProactive();
      openChat();
      trackEvent('proactive_prompt_clicked', { message: proactiveMessage });
      // On cart page: auto-send the seeded message so the customer
      // immediately gets helpful advice without having to type anything
      if (liveCtx.pageType === 'cart' && proactiveAutoSend) {
        setTimeout(function () { sendMessage(proactiveAutoSend); }, 400);
        proactiveAutoSend = null;
      }
    });
  }

  // ── Chat open/close ───────────────────────────────────────────────────────
  var isOpen = false;
  var helpReturnFocus = null;

  function openHelpDraft(trigger) {
    if (!trigger || trigger.disabled || trigger.getAttribute('aria-disabled') === 'true' || !chatAccountIsCurrent()) return false;
    if (!panel) init();
    if (!panel || !inputEl) return false;
    helpReturnFocus = trigger;
    openChat();
    if (!isOpen) return false;
    var question = trigger.getAttribute('data-ema-chat-question');
    if (typeof question === 'string' && !inputEl.value && !inputEl.disabled && !isSending) {
      inputEl.value = question.replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').trim().slice(0, 1000);
      inputEl.style.height = 'auto';
      inputEl.style.height = Math.min(inputEl.scrollHeight, 100) + 'px';
    }
    if (!inputEl.disabled) inputEl.focus();
    return true;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = target && typeof target.closest === 'function' ? target.closest('[data-ema-chat-help]') : null;
    if (!trigger || event.defaultPrevented) return;
    event.preventDefault();
    openHelpDraft(trigger);
  });

  function openChat() {
    if (isOpen || !chatAccountIsCurrent()) return;
    handleChatPrivacyChange();
    isOpen = true;
    refreshCart();
    if (!contextEnginesStarted) {
      contextEnginesStarted = true;
      if (liveCtx.pageType === 'product') setupSuitabilityBadge();
      if (liveCtx.pageType === 'cart') setupCartIntelPanel();
    }
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    panel.setAttribute('aria-modal', 'true');
    fab.classList.add('is-open');
    var fw = document.getElementById('ema-fab-wrap');
    if (fw) fw.classList.add('is-open');
    panel.classList.add('is-open');
    document.getElementById('ema-chat-badge').hidden = true;
    if (chatHistory.length === 0) {
      // Fresh conversation — show welcome
      if (!state.hasOpenedChat) {
        state.hasOpenedChat = true;
        saveState();
      }
      showWelcomeMessage();
    } else if (messagesEl.children.length === 0) {
      // History exists from a previous page — restore it silently
      restoreHistory();
    }
    setTimeout(function () { inputEl.focus(); }, 300);
    trackEvent('chatbot_opened', { pageType: liveCtx.pageType });
  }

  function closeChat() {
    if (!isOpen) return;
    isOpen = false;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('aria-modal', 'false');
    fab.classList.remove('is-open');
    var fw = document.getElementById('ema-fab-wrap');
    if (fw) fw.classList.remove('is-open');
    var returnTarget = helpReturnFocus;
    helpReturnFocus = null;
    setTimeout(function () {
      if (!isOpen) {
        panel.hidden = true;
        if (returnTarget && returnTarget.isConnected && typeof returnTarget.focus === 'function') returnTarget.focus();
        else fab.focus();
      }
    }, 350);
    trackEvent('chatbot_closed', { messageCount: chatHistory.length });
  }

  function toggleChat() {
    isOpen ? closeChat() : openChat();
  }

  // Focus trap inside panel when open
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) { closeChat(); return; }
    if (e.key !== 'Tab' || !isOpen) return;
    var focusable = panel.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  });

  // ── Restore history across page navigations ───────────────────────────────
  function restoreHistory() {
    // Render without entry animation so all messages appear instantly
    messagesEl.classList.add('ema-no-animate');
    chatHistory.forEach(function (msg) {
      if (msg.role === 'assistant') {
        renderBotMessage(msg.content);
      } else if (msg.role === 'user') {
        renderUserMessage(msg.content);
      }
    });
    messagesEl.classList.remove('ema-no-animate');
    scrollToBottom();
  }

  // ── Welcome message ───────────────────────────────────────────────────────
  function showWelcomeMessage() {
    var product = liveCtx.product;
    var msg, replies;

    if (product && product.title) {
      var isLivestock = product.isLivestock;
      if (isLivestock) {
        msg     = 'Hi! I can help you find out if the ' + product.title + ' suits your tank — care level, compatibility, tank size, and more. What would you like to know?';
        replies = ['Is it reef safe?', 'Care difficulty?', 'Tank size needed', 'Compatibility help'];
      } else {
        msg     = 'Hi! I can help with any questions about the ' + product.title + ' — specs, suitability, or comparisons with other options. What\'s on your mind?';
        replies = ['Tell me more', 'How does it compare?', 'Is this right for me?'];
      }
    } else if (liveCtx.pageType === 'cart') {
      msg     = 'Hi! I can do a quick compatibility check on your cart, or help with any questions before you order. What would you like to know?';
      replies = ['Check compatibility', 'Shipping questions', 'What else do I need?'];
    } else if (liveCtx.pageType === 'collection') {
      msg     = 'Hi! Tell me about your tank and I can help narrow down the options in this collection.';
      replies = ['My tank is 100L', 'I\'m a beginner', 'What\'s easiest to keep?'];
    } else {
      msg     = 'Hi! I\'m EMA\'s reef assistant. I can help with livestock care, equipment selection, water chemistry, and more. What are you looking for today?';
      replies = ['Help me choose a fish', 'Coral advice', 'Equipment help', 'I\'m a beginner'];
    }

    renderBotMessage(msg);
    renderQuickReplies(replies);
    chatHistory.push({ role: 'assistant', content: msg });
    saveHistory();
  }

  // ── Send message ──────────────────────────────────────────────────────────
  var isSending = false;

  function submitInput() {
    var text = inputEl.value.trim();
    if (!text || isSending || !isOpen || !chatAccountIsCurrent()) return;
    sendMessage(text);
  }

  function setSending(state) {
    isSending = state;
    var sendBtn = document.getElementById('ema-chat-send');
    if (sendBtn) {
      sendBtn.disabled = state;
      sendBtn.style.opacity = state ? '0.4' : '';
    }
    if (inputEl) inputEl.disabled = state;
  }

  var _lastSentText = '';

  function sendMessage(text) {
    if (!text || isSending || !isOpen || !chatAccountIsCurrent()) return;
    _lastSentText = text;
    setSending(true);

    inputEl.value  = '';
    inputEl.style.height = 'auto';
    quickRepliesEl.innerHTML = '';
    renderUserMessage(text);
    chatHistory.push({ role: 'user', content: text });
    saveHistory();

    // Detect intent keywords for event tracking
    var lower = text.toLowerCase();
    if (lower.includes('compat')) trackEvent('compatibility_question_asked', {});
    else if (lower.includes('ship')) trackEvent('shipping_question_asked', {});
    else if (lower.includes('suitable') || lower.includes('care')) trackEvent('livestock_suitability_question', {});

    showTyping();

    // Build fresh context snapshot with live datetime and customer
    var _now = new Date();
    var _days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var ctx = Object.assign({}, liveCtx, {
      session: behaviorAllowed() ? Object.assign({}, liveCtx.session, {
        timeOnPage:Math.floor((Date.now()-pageStartTime)/1000)
      }) : {},
      datetime: {
        iso:       _now.toISOString(),
        localDate: _now.getFullYear() + '-' +
                   String(_now.getMonth() + 1).padStart(2, '0') + '-' +
                   String(_now.getDate()).padStart(2, '0'),
        localTime: String(_now.getHours()).padStart(2, '0') + ':' +
                   String(_now.getMinutes()).padStart(2, '0'),
        dayOfWeek: _days[_now.getDay()],
        timezone:  (typeof Intl !== 'undefined' && Intl.DateTimeFormat)
                     ? Intl.DateTimeFormat().resolvedOptions().timeZone
                     : 'unknown',
      },
      customer: CUSTOMER,
    });

    fetch(API_URL + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id:  sessionId,
        customer_id: CUSTOMER_ID || undefined,
        message:     text,
        history:     chatHistory.slice(-16),
        context:     ctx,
      }),
    })
    .then(function (r) { if (!r.ok) throw new Error('Chat request failed'); return r.json(); })
    .then(function (data) {
      if (!chatAccountIsCurrent()) throw new Error('Chat account changed');
      hideTyping();

      if (!data || data.error) {
        renderBotMessage('Sorry, I\'m having a technical issue right now. Please try again or contact the EMA team directly.');
        setSending(false);
        return;
      }

      var extra = '';
      if (data.products?.length) extra += renderProductCards(data.products);
      if (data.discount)         extra += renderDiscount(data.discount);

      if (typeof data.reply !== 'string') throw new Error('Chat reply unavailable');
      renderBotMessage(data.reply, extra);
      chatHistory.push({ role: 'assistant', content: data.reply });
      saveHistory();

      if (data.discount) {
        state.discountOffered = true;
        saveState();
        document.getElementById('ema-chat-badge').hidden = false;
        trackEvent('discount_offered', {});
      }

      renderQuickReplies(data.suggested_replies);

      if (data.handoff_recommended) {
        // Append subtle handoff suggestion
        var hint = document.createElement('div');
        hint.className = 'ema-handoff-hint';
        hint.innerHTML = '<button onclick="document.getElementById(\'ema-chat-handoff\').click()">Connect with the EMA team for personalised advice →</button>';
        messagesEl.appendChild(hint);
        scrollToBottom();
      }

      setSending(false);
    })
    .catch(function (err) {
      console.warn('[EMA Chat] Requested response could not be completed.');
      hideTyping();
      var retryText = _lastSentText;
      // Pass plain text to renderBotMessage (nl2br HTML-escapes its input).
      // The retry button is injected via the `extra` second argument so it
      // renders as real HTML rather than escaped text.
      var errEl = renderBotMessage(
        'I\'m having a connection issue — the server may be waking up.',
        '<button class="ema-retry-btn" style="' +
          'display:inline-block;margin-top:8px;padding:6px 14px;' +
          'background:#29b6e8;color:#fff;border:none;border-radius:20px;' +
          'font-size:0.85em;font-weight:600;cursor:pointer;' +
        '">Try again</button>'
      );
      errEl.querySelector('.ema-retry-btn').addEventListener('click', function () {
        errEl.remove();
        sendMessage(retryText);
      });
      setSending(false);
    });
  }

  // ── Handoff form ──────────────────────────────────────────────────────────
  function showHandoffForm() {
    trackEvent('handoff_requested', { pageType: liveCtx.pageType });

    // Replace quick replies area with form
    quickRepliesEl.innerHTML = '';
    renderBotMessage('Sure — I\'ll connect you with the EMA team. Could you share your name, email, and main question?');

    var form = document.createElement('div');
    form.className = 'ema-handoff-form';
    form.innerHTML =
      '<input class="ema-handoff-input" id="ema-hf-name"  type="text"  placeholder="Your name"  autocomplete="name">' +
      '<input class="ema-handoff-input" id="ema-hf-email" type="email" placeholder="Email address" autocomplete="email">' +
      '<textarea class="ema-handoff-input ema-handoff-textarea" id="ema-hf-msg" rows="3" placeholder="Your question or concern…"></textarea>' +
      '<button class="ema-handoff-submit" id="ema-hf-submit">Send to EMA team</button>';
    messagesEl.appendChild(form);
    scrollToBottom();

    document.getElementById('ema-hf-submit').addEventListener('click', function () {
      submitHandoff(form);
    });
  }

  function submitHandoff(form) {
    var name  = document.getElementById('ema-hf-name').value.trim();
    var email = document.getElementById('ema-hf-email').value.trim();
    var msg   = document.getElementById('ema-hf-msg').value.trim();

    if (!msg) {
      document.getElementById('ema-hf-msg').focus();
      return;
    }

    form.innerHTML = '<p class="ema-handoff-sending">Sending…</p>';

    fetch(API_URL + '/api/chat/handoff', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: sessionId,
        name, email, question: msg,
        context: liveCtx,
        history: chatHistory.slice(-10),
      }),
    })
    .then(function (r) { if (!r.ok) throw new Error('Chat request failed'); return r.json(); })
    .then(function (data) {
      if (!chatAccountIsCurrent() || !data || data.error || data.success === false) throw new Error('Handoff was not confirmed');
      form.remove();
      renderBotMessage(data.message || 'Done! The EMA team will be in touch soon. Typical response time is a few hours during business hours (NZT).');
    })
    .catch(function () {
      form.remove();
      renderBotMessage('We could not confirm that your message was sent. Please try again or email the EMA team at info@easternmarine.co.nz.');
    });
  }

  // ── Personalised greeting builder ────────────────────────────────────────

  function timeOfDay() {
    var h = new Date().getHours();
    if (h < 12) return 'Good morning';
    if (h < 17) return 'Good afternoon';
    return 'Good evening';
  }

  function productFollowUp(type, title) {
    var t = (type || '').toLowerCase();
    if (t.indexOf('fish') !== -1) {
      return 'How is your ' + title + ' settling into the tank — any issues so far?';
    }
    if (t.indexOf('coral') !== -1) {
      return 'How is your ' + title + ' adapting under your lights?';
    }
    if (t.indexOf('equipment') !== -1 || t.indexOf('pump') !== -1 ||
        t.indexOf('filter') !== -1 || t.indexOf('light') !== -1 || t.indexOf('skimmer') !== -1) {
      return 'Has your ' + title + ' been working well for you?';
    }
    if (t.indexOf('food') !== -1 || t.indexOf('supplement') !== -1) {
      return 'Are your animals enjoying the ' + title + '?';
    }
    // generic fallback
    return 'How has your ' + title + ' been going?';
  }

  function buildPersonalisedGreeting() {
    var greeting = timeOfDay();

    if (!CUSTOMER.isLoggedIn) return null; // guests use context-based triggers

    var name = CUSTOMER.firstName ? ', ' + CUSTOMER.firstName : '';

    if (CUSTOMER.lastOrder) {
      var title    = CUSTOMER.lastOrder.productTitle || 'recent purchase';
      var type     = CUSTOMER.lastOrder.productType  || '';
      var followUp = productFollowUp(type, title);
      return greeting + name + '! 👋 ' + followUp;
    }

    // Logged in but no orders yet
    return greeting + name + '! 👋 Welcome back — how can I help with your reef today?';
  }

  // ── Proactive prompt system ───────────────────────────────────────────────
  var proactiveMessage    = '';
  var proactiveAutoSend   = null;  // message auto-sent to AI when cart CTA clicked
  var proactiveFired      = false;
  var PROACTIVE_COOLDOWN  = 4 * 60 * 60 * 1000; // 4 hours between proactive per session

  function canShowProactive() { return false; }

  function showProactive(message, delay) {
    delay = delay || 0;
    setTimeout(function () {
      if (!canShowProactive()) return;
      proactiveMessage = message;
      proactiveFired = true;
      state.proactiveSeen = Date.now();
      saveState();

      document.getElementById('ema-proactive-text').textContent = message;
      proactiveBubble.hidden = false;
      proactiveBubble.classList.add('is-visible');
      document.getElementById('ema-chat-badge').hidden = false;

      trackEvent('proactive_prompt_shown', {
        message: message.slice(0, 60),
        pageType: liveCtx.pageType,
      });
    }, delay);
  }

  function dismissProactive() {
    proactiveBubble.classList.remove('is-visible');
    setTimeout(function () { proactiveBubble.hidden = true; }, 350);
    document.getElementById('ema-chat-badge').hidden = true;
    trackEvent('proactive_prompt_dismissed', {});
  }

  function setupProactiveTriggers() {}

  // ── Init ──────────────────────────────────────────────────────────────────
  // ── Engine helpers ────────────────────────────────────────────────────────

  function enginePost(path, body) {
    if (!isOpen || !chatAccountIsCurrent()) return Promise.reject(new Error('Open chat to request help'));
    return fetch(API_URL + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok || !chatAccountIsCurrent()) throw new Error('Requested help unavailable');
      return r.json();
    });
  }

  // ── Reef profile helpers ──────────────────────────────────────────────────

  function loadLocalProfile() {
    if (!chatAccountIsCurrent()) return null;
    if (scopedProfile) return scopedProfile;
    try {
      var value = JSON.parse(lsGet(PROFILE_KEY) || 'null');
      var owner = CUSTOMER_ID || CHAT_OWNER;
      if (!value || value.owner !== owner || value.version !== 2 || !Number.isFinite(value.savedAt) ||
          value.savedAt > Date.now() || Date.now() - value.savedAt > 30*24*60*60*1000) return null;
      scopedProfile = value.profile || null;
      return scopedProfile;
    } catch (error) { return null; }
  }
  function cacheLocalProfile(profile) {
    if (!chatAccountIsCurrent()) return;
    scopedProfile = profile;
    lsSet(PROFILE_KEY, JSON.stringify({version:2,owner:CUSTOMER_ID || CHAT_OWNER,savedAt:Date.now(),profile:profile}));
  }
  function saveLocalProfile(profile) {
    cacheLocalProfile(profile);
    var payload = {reef_profile:profile};
    if (CUSTOMER_ID) payload.customer_id = CUSTOMER_ID;
    else payload.session_id = sessionId;
    return enginePost('/api/reef/profile',payload).then(function (result) {
      if (!result || result.success === false || result.error) throw new Error('Profile save was not confirmed');
      if (!CUSTOMER_ID) return false;
      return new Promise(function (resolve) {
        syncCustomerProfile(function (saved) {
          resolve(!!saved && Object.keys(profile).every(function (key) { return saved[key] === profile[key]; }));
        },false);
      });
    }).catch(function () { return false; });
  }
  function syncCustomerProfile(callback, allowBackup) {
    if (!isOpen || !chatAccountIsCurrent()) { if (callback) callback(null); return; }
    if (!CUSTOMER_ID) { if (callback) callback(loadLocalProfile()); return; }
    fetch(API_URL + '/api/reef/profile?customer_id=' + encodeURIComponent(CUSTOMER_ID), {headers:{Accept:'application/json'}})
      .then(function (response) { if (!response.ok) throw new Error('Profile unavailable'); return response.json(); })
      .then(function (data) {
        if (!chatAccountIsCurrent()) { if (callback) callback(null); return; }
        var profile = data && (data.profile || data.reef_profile) || null;
        cacheLocalProfile(profile);
        if (!profile) lsRemove(PROFILE_KEY);
        if (callback) callback(profile);
      }).catch(function () {
        if (callback) callback(allowBackup === false ? null : loadLocalProfile());
      });
  }

  // Render action chips that invoke a callback instead of sending to the AI
  function renderActionReplies(options, onSelect) {
    if (!quickRepliesEl) return;
    quickRepliesEl.innerHTML = '';
    options.forEach(function(opt) {
      var btn = document.createElement('button');
      btn.className = 'ema-quick-reply';
      btn.textContent = opt.label;
      btn.addEventListener('click', function() {
        quickRepliesEl.innerHTML = '';
        renderUserMessage(opt.label);
        onSelect(opt);
      });
      quickRepliesEl.appendChild(btn);
    });
  }

  // 3-step profile wizard — collects tank size, experience, reef type
  function startProfileSetup(onComplete) {
    var profile = {};

    openChat();

    renderBotMessage('To personalise this for you — quick question: how big is your tank?');
    renderActionReplies([
      { label: 'Under 100L (nano)',  tank_size_litres: 75  },
      { label: '100–200L',          tank_size_litres: 150 },
      { label: '200–400L',          tank_size_litres: 300 },
      { label: 'Over 400L',         tank_size_litres: 500 },
    ], function(opt) {
      profile.tank_size_litres = opt.tank_size_litres;

      renderBotMessage('How long have you been keeping reef tanks?');
      renderActionReplies([
        { label: 'Just starting out',         experience_level: 'complete_beginner' },
        { label: '1–2 years (beginner)',       experience_level: 'beginner'          },
        { label: '2–5 years (intermediate)',   experience_level: 'intermediate'      },
        { label: '5+ years (experienced)',     experience_level: 'experienced'       },
      ], function(opt2) {
        profile.experience_level = opt2.experience_level;

        renderBotMessage('What type of reef are you keeping?');
        renderActionReplies([
          { label: 'Fish only / FOWLR',      reef_type: 'fish_only_with_live_rock' },
          { label: 'Mixed reef (soft + LPS)', reef_type: 'mixed_reef'              },
          { label: 'LPS dominant',            reef_type: 'lps_dominant'            },
          { label: 'SPS / high-end coral',    reef_type: 'sps_dominant'            },
        ], function(opt3) {
          profile.reef_type = opt3.reef_type;
          saveLocalProfile(profile).then(function (confirmed) {
            renderBotMessage(confirmed ? 'Profile saved to your account. Let me check this setup…' : 'I can use these details for this chat, but could not confirm an account save.');
            if (onComplete) onComplete(profile);
          });
        });
      });
    });
  }

  // ── Suitability badge (product pages) ────────────────────────────────────

  function injectEngineStyles() {
    if (document.getElementById('ema-engine-styles')) return;
    var s = document.createElement('style');
    s.id = 'ema-engine-styles';
    s.textContent = [
      // ── Suitability badge ──────────────────────────────────────────
      '#ema-suit-wrap{margin:12px 0 16px}',
      // Base badge — block-level, aligned with product info
      '.ema-suit-badge{display:flex;align-items:flex-start;gap:11px;padding:12px 14px;',
        'border-radius:var(--btn-border-radius,6px);border:1px solid;background:none;',
        'font-family:inherit;line-height:1.4;width:100%;text-align:left;',
        'box-sizing:border-box;transition:filter .15s,box-shadow .15s;cursor:default}',
      '.ema-suit-badge.ema-suit-clickable{cursor:pointer}',
      '.ema-suit-badge.ema-suit-clickable:hover{filter:brightness(.97);box-shadow:0 1px 5px rgba(0,0,0,.09)}',
      // Icon circle
      '.ema-suit-icon{flex-shrink:0;width:20px;height:20px;border-radius:50%;',
        'display:flex;align-items:center;justify-content:center;',
        'font-size:11px;font-weight:700;margin-top:1px}',
      // Text block
      '.ema-suit-body{flex:1;min-width:0}',
      '.ema-suit-main{display:block;font-size:13.5px;font-weight:600}',
      '.ema-suit-sub{display:block;font-size:12px;font-weight:400;margin-top:3px;opacity:.82}',
      // Colour states
      '.suit-ok{background:#f1faf1;color:#1a5c1a;border-color:#9ecf9e}',
      '.suit-ok .ema-suit-icon{background:#2e7d32;color:#fff}',
      '.suit-warn{background:#fffbf0;color:#6b3800;border-color:#e8c840}',
      '.suit-warn .ema-suit-icon{background:#e65100;color:#fff}',
      '.suit-bad{background:#fff5f5;color:#8b1a1a;border-color:#f0a8a8}',
      '.suit-bad .ema-suit-icon{background:#c62828;color:#fff}',
      '.suit-load{background:#f7f7f7;color:#aaa;border-color:#e0e0e0}',
      '.suit-load .ema-suit-icon{background:#ccc;color:#fff}',
      // Profile CTA button (shown in chat when no profile set up)
      '.ema-profile-cta{display:flex;align-items:center;gap:10px;margin-top:10px;',
        'padding:11px 14px;border-radius:8px;background:#0a1628;color:#fff;',
        'text-decoration:none;font-family:inherit;font-size:0.875rem;font-weight:600;',
        'transition:background .15s;cursor:pointer;border:none;width:100%;box-sizing:border-box}',
      '.ema-profile-cta:hover{background:#1a3a58;color:#fff}',
      '.ema-profile-cta-icon{font-size:1.1rem;flex-shrink:0}',
      '.ema-profile-cta-text{flex:1}',
      '.ema-profile-cta-text strong{display:block;font-size:0.875rem}',
      '.ema-profile-cta-text span{display:block;font-size:0.75rem;opacity:.75;font-weight:400;margin-top:1px}',
      '.ema-profile-cta-arrow{opacity:.6;font-size:1rem;flex-shrink:0}',
      // Cart panel
      '#ema-cart-panel{background:#f0f7ff;border:1px solid #b8d8f0;',
        'border-radius:12px;padding:13px 15px;margin:14px 0;font-size:13.5px;color:#2C2C2C}',
      '#ema-cart-panel h4{color:#0A4F6E;font-size:13.5px;font-weight:600;margin:0 0 8px}',
      '.ema-cw{color:#c0392b;padding:3px 0 3px 18px;position:relative;font-size:13px}',
      '.ema-cw::before{content:"⚠";position:absolute;left:0}',
      '.ema-ct{color:#2e7d32;padding:3px 0 3px 18px;position:relative;font-size:13px}',
      '.ema-ct::before{content:"✓";position:absolute;left:0}',
      '.ema-cart-chat-btn{margin-top:9px;background:#0A4F6E;color:#fff;border:none;',
        'border-radius:8px;padding:7px 14px;font-size:13px;cursor:pointer;font-family:inherit}',
      '.ema-cart-chat-btn:hover{background:#1a7fa3}',
    ].join('');
    document.head.appendChild(s);
  }

  /**
   * Returns true if the compatibility badge should appear for this product.
   * Covers: all livestock (fish, coral, invert, anemone) AND equipment where
   * the AI can meaningfully reference the customer's tank profile (pumps,
   * skimmers, heaters, lights, chillers, controllers, ATOs, dosers, UV, etc.)
   */
  // Returns true when the product is biological livestock (fish, coral, invert, anemone).
  // Equipment products return false — they get different badge text / AI prompt.
  function isLivestockProduct(product) {
    if (!product) return false;
    var type  = (product.type  || '').toLowerCase().trim();
    var title = (product.title || '').toLowerCase();
    var tags  = (product.tags  || []).map(function (t) { return t.toLowerCase(); });

    // Explicit dry-goods types — never livestock regardless of title keywords
    var dryTypes = ['equipment', 'hardware', 'additive', 'supplement', 'food',
                    'dry goods', 'dry_goods', 'chemical', 'adhesive', 'glue', 'tool', 'tools'];
    for (var d = 0; d < dryTypes.length; d++) {
      if (type.indexOf(dryTypes[d]) !== -1) return false;
    }

    var lsTypes = ['fish', 'coral', 'invert', 'invertebrate', 'anemone'];
    if (lsTypes.indexOf(type) !== -1) return true;
    if (product.isLivestock) return true;

    var lsTags = ['fish', 'coral', 'invert', 'livestock', 'anemone', 'shrimp', 'crab', 'snail', 'urchin', 'starfish'];
    for (var i = 0; i < tags.length; i++) {
      for (var j = 0; j < lsTags.length; j++) {
        if (tags[i].indexOf(lsTags[j]) !== -1) return true;
      }
    }

    var lsWords = [
      'coral', 'acropora', 'montipora', 'euphyllia', 'goniopora', 'galaxea',
      'hammer', 'torch', 'frogspawn', 'alveopora',
      'frag', 'fragment', 'colony', 'acan', 'chalice', 'blastomussa',
      'lobophyllia', 'favites', 'platygyra', 'turbinaria', 'caulastrea',
      'seriatopora', 'stylophora', 'pocillopora',
      'fish', 'clown', 'nemo', 'tang', 'wrasse', 'goby', 'blenny',
      'damsel', 'anthias', 'chromis', 'basslet', 'dottyback', 'hawkfish',
      'angelfish', 'butterflyfish', 'foxface', 'rabbitfish', 'mandarin',
      'anemone', 'shrimp', 'crab', 'urchin', 'starfish', 'nudibranch',
      'sea star', 'feather duster', 'snail', 'hermit',
    ];
    for (var k = 0; k < lsWords.length; k++) {
      if (title.indexOf(lsWords[k]) !== -1) return true;
    }
    return false;
  }

  function isCompatibilityRelevant(product) {
    if (!product) return false;

    var type  = (product.type  || '').toLowerCase().trim();
    var title = (product.title || '').toLowerCase();
    var tags  = (product.tags  || []).map(function (t) { return t.toLowerCase(); });

    // Dry goods / equipment — never show compatibility badge
    var dryTypes = ['equipment', 'hardware', 'additive', 'supplement', 'food',
                    'dry goods', 'dry_goods', 'chemical', 'adhesive', 'glue', 'tool', 'tools'];
    for (var d = 0; d < dryTypes.length; d++) {
      if (type.indexOf(dryTypes[d]) !== -1) return false;
    }

    // Also check title for dry goods keywords (catches products with unset/incorrect type)
    var dryKeywords = ['glue', 'adhesive', 'food', 'feed', 'supplement', 'salt', 'test', 'kit',
                       'light', 'heater', 'pump', 'filter', 'sand', 'substrate', 'rock', 'skeleton',
                       'air stone', 'airstone', 'powerhead', 'probe', 'meter', 'thermometer',
                       'timer', 'refugium', 'macro', 'algae', 'powder', 'pellet', 'flake',
                       'liquid', 'solution', 'enzyme', 'bacteria', 'cleaner', 'trap',
                       'cover', 'glass', 'lens', 'tubing', 'hose', 'valve', 'clip', 'holder'];
    for (var i = 0; i < dryKeywords.length; i++) {
      if (title.indexOf(dryKeywords[i]) !== -1) return false;
    }

    // ── 1. Known livestock product types ──────────────────────────────────────
    var lsTypes = ['fish', 'coral', 'invert', 'invertebrate', 'anemone'];
    if (lsTypes.indexOf(type) !== -1) return true;
    if (product.isLivestock) return true;

    // ── 2. Livestock tags ──────────────────────────────────────────────────────
    var lsTags = ['fish', 'coral', 'invert', 'livestock', 'anemone', 'shrimp', 'crab', 'snail', 'urchin', 'starfish'];
    for (var i = 0; i < tags.length; i++) {
      for (var j = 0; j < lsTags.length; j++) {
        if (tags[i].indexOf(lsTags[j]) !== -1) return true;
      }
    }

    // ── 3. Livestock title keywords (catches blank-type coral frags, fish) ────
    var lsWords = [
      'coral', 'acropora', 'montipora', 'euphyllia', 'goniopora', 'galaxea',
      'hammer', 'torch', 'frogspawn', 'torch coral', 'alveopora',
      'frag', 'fragment', 'colony', 'acan', 'chalice', 'blastomussa',
      'lobophyllia', 'favites', 'platygyra', 'turbinaria', 'caulastrea',
      'seriatopora', 'stylophora', 'pocillopora',
      'fish', 'clown', 'nemo', 'tang', 'wrasse', 'goby', 'blenny',
      'damsel', 'anthias', 'chromis', 'basslet', 'dottyback', 'hawkfish',
      'angelfish', 'butterflyfish', 'foxface', 'rabbitfish', 'mandarin',
      'anemone', 'shrimp', 'crab', 'urchin', 'starfish', 'nudibranch',
      'sea star', 'feather duster', 'snail', 'hermit',
    ];
    for (var k = 0; k < lsWords.length; k++) {
      if (title.indexOf(lsWords[k]) !== -1) return true;
    }

    return false;
  }

  function setupSuitabilityBadge() {
    var product = liveCtx.product || PAGE_CTX.product;
    if (!product || !product.handle) return;

    // Only show on products where a meaningful compatibility assessment is possible
    if (!isCompatibilityRelevant(product)) return;

    // Try common add-to-cart selectors across popular Shopify themes
    var anchor = (
      document.querySelector('.product-form__submit') ||
      document.querySelector('[name="add"]') ||
      document.querySelector('#AddToCart') ||
      document.querySelector('[data-add-to-cart]') ||
      document.querySelector('.product-single__add-to-cart') ||
      document.querySelector('[data-product-form] button[type="submit"]') ||
      document.querySelector('.product__info-container')
    );
    if (!anchor) return;

    var wrap  = document.createElement('div');
    wrap.id   = 'ema-suit-wrap';
    var badge = document.createElement('button');
    badge.className = 'ema-suit-badge suit-load';
    badge.setAttribute('disabled', 'disabled');
    badge.innerHTML = '<span class="ema-suit-icon">…</span>' +
      '<span class="ema-suit-body"><span class="ema-suit-main">Checking compatibility…</span></span>';
    wrap.appendChild(badge);

    var insertBefore = anchor.closest('form') || anchor.parentNode;
    insertBefore.parentNode.insertBefore(wrap, insertBefore);

    var productCategory = isLivestockProduct(product) ? 'livestock' : 'equipment';

    function fetchSuitability(profile, callback) {
      var body = {
        session_id:       sessionId,
        product_handle:   product.handle,
        product_category: productCategory,
      };
      if (profile) body.reef_profile = profile;
      if (CUSTOMER_ID) body.customer_id = CUSTOMER_ID;
      return enginePost('/api/engines/suitability', body)
        .then(function(data) { callback(null, data); })
        .catch(function(err) { callback(err, null); });
    }

    // Helper: open chat and immediately auto-send a compatibility question.
    // The AI will answer using the customer's tank profile + product context.
    function openChatAndAsk(question) {
      openChat();
      // Give the panel animation a head-start, then auto-send
      setTimeout(function () {
        if (!isSending) {
          // Clear the welcome quick replies so the auto-question flows cleanly
          if (quickRepliesEl) quickRepliesEl.innerHTML = '';
          sendMessage(question);
        }
      }, 280);
    }

    function applyVerdict(data, resolvedProfile) {
      if (data.error || !data.verdict) { wrap.remove(); return; }

      // Consider the profile "set" if any meaningful tank data is present.
      // This covers both the original fields and new fields added in the redesign.
      var hasProfile = !!(resolvedProfile && (
        resolvedProfile.tank_size_litres || resolvedProfile.reef_type ||
        resolvedProfile.experience_level || resolvedProfile.tank_name ||
        resolvedProfile.flow_preference  ||
        (resolvedProfile.lighting  && (resolvedProfile.lighting.par_at_top || resolvedProfile.lighting.par_at_mid ||
                                       resolvedProfile.lighting.brand || resolvedProfile.lighting.type)) ||
        (resolvedProfile.equipment && Object.values(resolvedProfile.equipment).some(Boolean)) ||
        (resolvedProfile.current_coral_types && resolvedProfile.current_coral_types.length > 0) ||
        (resolvedProfile.current_livestock   && resolvedProfile.current_livestock.length   > 0) ||
        (resolvedProfile.current_parameters  && Object.keys(resolvedProfile.current_parameters).length > 0) ||
        (resolvedProfile.goals               && resolvedProfile.goals.length > 0)
      ));

      var verdict   = data.verdict || 'caution';
      var isEquip   = (productCategory === 'equipment');

      // ── Badge text maps: livestock vs equipment ────────────────────────────
      // Each entry: [stateClass, iconChar, mainText, subText|null]
      var map;
      if (isEquip) {
        map = hasProfile ? {
          yes:     ['suit-ok',   '✓', 'Looks like a great fit for your tank', null],
          caution: ['suit-warn', '!', 'Might work — worth a quick check',     'Chat to us and we\'ll help you decide'],
          no:      ['suit-bad',  '✕', 'Might not be right for your setup',    'Chat to us before you buy'],
        } : {
          yes:     ['suit-load', '!', 'Want to know if this suits your tank?', 'Set up your reef profile for a personalised check ↗'],
          caution: ['suit-load', '!', 'Want to know if this suits your tank?', 'Set up your reef profile for a personalised check ↗'],
          no:      ['suit-load', '!', 'Want to know if this suits your tank?', 'Set up your reef profile for a personalised check ↗'],
        };
      } else {
        map = hasProfile ? {
          yes:     ['suit-ok',   '✓', 'Looks like a good match for your reef', null],
          caution: ['suit-warn', '!', 'Could work, but worth checking first',  'Chat to us and we\'ll walk you through it'],
          no:      ['suit-bad',  '✕', 'Might not suit your reef',              'Chat to us before you buy — we\'re happy to help'],
        } : {
          yes:     ['suit-load', '!', 'Is this right for your reef?', 'Set up your reef profile for a personalised check ↗'],
          caution: ['suit-load', '!', 'Is this right for your reef?', 'Set up your reef profile for a personalised check ↗'],
          no:      ['suit-load', '!', 'Is this right for your reef?', 'Set up your reef profile for a personalised check ↗'],
        };
      }

      var row        = map[verdict] || map['caution'];
      var stateClass = row[0];
      var iconChar   = row[1];
      var mainText   = row[2];
      var subText    = row[3];

      badge.className = 'ema-suit-badge ' + stateClass + ' ema-suit-clickable';
      badge.innerHTML =
        '<span class="ema-suit-icon">' + iconChar + '</span>' +
        '<span class="ema-suit-body">' +
          '<span class="ema-suit-main">' + mainText + '</span>' +
          (subText ? '<span class="ema-suit-sub">' + subText + '</span>' : '') +
        '</span>';
      badge.removeAttribute('disabled');

      // ── Click handler ──────────────────────────────────────────────────────
      badge.onclick = null;
      badge.addEventListener('click', function () {
        if (!hasProfile) {
          // No profile — prompt the customer to set up their full reef profile
          openChat();

          var profilePageUrl = CUSTOMER.isLoggedIn
            ? '/pages/my-reef-tank'
            : '/account/login?return_url=' + encodeURIComponent('/pages/my-reef-tank');

          var ctaHtml =
            '<a href="' + profilePageUrl + '" class="ema-profile-cta">' +
              '<span class="ema-profile-cta-icon">🐠</span>' +
              '<span class="ema-profile-cta-text">' +
                '<strong>' + (CUSTOMER.isLoggedIn ? 'Set up my reef profile' : 'Sign in & set up my profile') + '</strong>' +
                '<span>Tank size, livestock, lighting & more — takes ~2 min</span>' +
              '</span>' +
              '<span class="ema-profile-cta-arrow">→</span>' +
            '</a>';

          var promptMsg = CUSTOMER.isLoggedIn
            ? 'To get a personalised setup check for every product in our store, set up your Reef Tank Profile. Once saved, equipment pages will show whether each product\'s spec is a good match for your tank.'
            : 'Sign in and set up your Reef Tank Profile to get personalised setup checks on every product.';

          renderBotMessage(promptMsg, ctaHtml);
          return;
        }

        if (verdict === 'yes') {
          // Good match — open chat and surface the summary
          openChat();
          if (chatHistory.length === 0 && data.summary) {
            renderBotMessage(data.summary);
            chatHistory.push({ role: 'assistant', content: data.summary });
            saveHistory();
            var defaultReplies = isEquip
              ? ['What size tank is this designed for?', 'How does this compare to alternatives?']
              : ['What do I need to keep this?', 'Care requirements?'];
            renderQuickReplies(data.suggested_replies || defaultReplies);
          }
        } else {
          // Caution or no — auto-open chat with a tailored question
          var autoQuestion = isEquip
            ? 'Can you tell me if the ' + product.title + ' is the right size and spec for my tank?'
            : 'Can you tell me whether ' + product.title + ' is a good fit for my reef tank and what I need to know to keep it successfully?';
          openChatAndAsk(autoQuestion);
        }
      });
    }

    // Sync profile from server first (uses customer_id if logged in, falls back
    // to localStorage for guests), then run the suitability check with fresh data
    syncCustomerProfile(function(profile) {
      fetchSuitability(profile, function(err, data) {
        if (err || !data) { wrap.remove(); return; }
        applyVerdict(data, profile);
      });
    });
  }

  // ── Cart intelligence panel (cart pages) ─────────────────────────────────

  function setupCartIntelPanel() {
    // Load live cart from Shopify
    fetch('/cart.js')
      .then(function (r) { if (!r.ok) throw new Error('Chat request failed'); return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;

        // Find checkout button injection point
        var target = (
          document.querySelector('[name="checkout"]') ||
          document.querySelector('.cart__checkout') ||
          document.querySelector('#CartCheckout') ||
          document.querySelector('[data-cart-checkout]') ||
          document.querySelector('.cart-footer')
        );
        if (!target) return;

        var panel   = document.createElement('div');
        panel.id    = 'ema-cart-panel';
        panel.innerHTML = '<h4>🛒 Checking cart compatibility…</h4>';

        var anchor = target.closest('form') || target.parentNode;
        anchor.parentNode.insertBefore(panel, anchor);

        // Pass the full Shopify cart object (items have title, handle, type, quantity, price)
        enginePost('/api/engines/cart-intel', {
          session_id: sessionId,
          cart: {
            items: cart.items.map(function (item) {
              return {
                title:    item.product_title || item.title || '',
                handle:   item.handle        || '',
                type:     item.product_type  || '',
                quantity: item.quantity      || 1,
                price:    item.price         || 0,
              };
            }),
            total_price: cart.total_price || 0,
          },
        }).then(function (data) {
          if (!data || data.error) { panel.remove(); return; }

          var warnings  = data.warnings          || [];
          var missing   = data.missing_essentials || [];
          var upsells   = (data.upsells           || []).slice(0, 2);
          var proactive = data.proactive_message;

          var html = '<h4>🛒 Cart Compatibility Check</h4>';

          if (!warnings.length && !missing.length) {
            html += '<div class="ema-ct">No compatibility issues — all good!</div>';
          } else {
            if (proactive) html += '<div class="ema-ct">' + escHtml(proactive) + '</div>';
            warnings.forEach(function (w) {
              var msg = typeof w === 'string' ? w : (w.message || w.issue || '');
              if (msg) html += '<div class="ema-cw">' + escHtml(msg) + '</div>';
            });
            missing.forEach(function (m) {
              var msg = typeof m === 'string' ? m : (m.item + (m.reason ? ' — ' + m.reason : ''));
              if (msg) html += '<div class="ema-cw">' + escHtml(msg) + '</div>';
            });
          }

          if (upsells.length) {
            html += '<div style="margin-top:7px;font-size:12.5px;color:#555">You might also need:</div>';
            upsells.forEach(function (u) {
              var name = typeof u === 'string' ? u : (u.item || u.name || '');
              if (name) html += '<div style="font-size:12.5px;color:#0A4F6E;padding:2px 0">→ ' + escHtml(name) + '</div>';
            });
          }

          html += '<button class="ema-cart-chat-btn">Chat about my cart</button>';
          panel.innerHTML = html;

          panel.querySelector('.ema-cart-chat-btn').addEventListener('click', function () {
            openChat();
            if (chatHistory.length === 0) {
              sendMessage('Can you check my cart for compatibility issues?');
            }
          });
        }).catch(function () { panel.remove(); });
      })
      .catch(function () {});
  }

  // ── Intent detection to route to specialist engines ───────────────────────

  var PROBLEM_SLUGS = {
    'algae': 'algae-outbreak',
    'cyano': 'cyano-outbreak',
    'cyanobacteria': 'cyano-outbreak',
    'white spot': 'ich-white-spot',
    'ich': 'ich-white-spot',
    'velvet': 'marine-velvet',
    'ammonia': 'ammonia-spike',
    'nitrate': 'high-nitrates',
    'nitrite': 'nitrite-spike',
    'phosphate': 'high-phosphates',
    'coral bleach': 'coral-bleaching',
    'bleach': 'coral-bleaching',
    'flatworm': 'flatworms',
    'aiptasia': 'aiptasia',
    'alk crash': 'alk-crash',
    'alkalinity crash': 'alk-crash',
  };

  function detectProblemSlug(text) {
    var lower = text.toLowerCase();
    for (var keyword in PROBLEM_SLUGS) {
      if (lower.indexOf(keyword) !== -1) return PROBLEM_SLUGS[keyword];
    }
    return null;
  }

  function renderEngineResultInChat(title, body, suggestions, products) {
    var extra = '';
    if (products && products.length) extra += renderProductCards(products);
    renderBotMessage(body, extra);
    chatHistory.push({ role: 'assistant', content: body });
    saveHistory();
    if (suggestions && suggestions.length) renderQuickReplies(suggestions);
  }

  // ── Problem solver shortcut ───────────────────────────────────────────────

  function tryProblemSolver(text, slug) {
    return enginePost('/api/engines/problem-solver', {
      session_id:   sessionId,
      problem_slug: slug,
    }).then(function (data) {
      if (data.error || !data.guide_title) return false;
      var body = '**' + escHtml(data.guide_title) + '**\n\n' +
        (data.overview || '') +
        (data.immediate_actions && data.immediate_actions.length
          ? '\n\n**Immediate actions:**\n' + data.immediate_actions.map(function (a) { return '• ' + a; }).join('\n')
          : '');
      renderEngineResultInChat(data.guide_title, data.overview || body, data.suggested_replies, data.products);
      return true;
    }).catch(function () { return false; });
  }

  // ── Success kit shortcut (on product pages) ───────────────────────────────

  function trySuccessKit(handle) {
    return enginePost('/api/engines/success-kit', {
      session_id:     sessionId,
      product_handle: handle,
    }).then(function (data) {
      if (data.error || !data.kit_items || !data.kit_items.length) return false;
      var body = (data.overview || 'Here\'s what you\'ll need to keep this thriving:');
      var prods = data.kit_items
        .filter(function (k) { return k.product; })
        .map(function (k) { return k.product; });
      renderEngineResultInChat('Success Kit', body, data.suggested_replies, prods);
      return true;
    }).catch(function () { return false; });
  }

  // Patch sendMessage to intercept engine-worthy intents
  var _originalSendMessage = sendMessage;
  sendMessage = function (text) {
    if (!text || isSending || !isOpen || !chatAccountIsCurrent()) return;
    var lower = text.toLowerCase();

    // Problem solver intent
    var slug = detectProblemSlug(text);
    if (slug && (lower.indexOf('tank') !== -1 || lower.indexOf('my') !== -1 ||
                 lower.indexOf('have') !== -1 || lower.indexOf('problem') !== -1 ||
                 lower.indexOf('issue') !== -1 || lower.indexOf('help') !== -1)) {
      // Still show the message and typing, but try engine first
      _originalSendMessage(text);
      return;
    }

    // Success kit intent on product page
    var product = liveCtx.product || PAGE_CTX.product;
    if (product && product.handle && (
      lower.indexOf('what do i need') !== -1 ||
      lower.indexOf('what else') !== -1 ||
      lower.indexOf('success kit') !== -1 ||
      lower.indexOf('equipment') !== -1 && lower.indexOf('need') !== -1
    )) {
      renderUserMessage(text);
      chatHistory.push({ role: 'user', content: text });
      saveHistory();
      showTyping();
      trySuccessKit(product.handle).then(function (handled) {
        hideTyping();
        if (!handled) {
          // Fall back to regular chat
          _originalSendMessage(text);
        }
      });
      return;
    }

    _originalSendMessage(text);
  };

  // ── Visitor Intelligence Telemetry ───────────────────────────────────────
  // Moved to ema-chat.liquid as an inline script so it fires immediately
  // on every page load without CDN caching delay. No-op here.

  // ── Init ──────────────────────────────────────────────────────────────────

  var widgetReady = false;
  function init() {
    if (widgetReady || !document.body) return;
    widgetReady = true;
    injectEngineStyles();
    buildWidget();
    // Help opens only through a visitor action. Context engines run in openChat.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
